import React, { useState, useCallback } from 'react';
import type { FC } from 'react';
import { useTranslation } from '@wix/cli-i18n';
import { Text, ConfirmInput, TextInput, Box } from '@wix/cli-ui-kit';
import { ContactUs } from './ContactUs.js';

interface Props {
  onSubmit: ({ feedback }: { feedback: string }) => void;
}

export const UserFeedbackForm: FC<Props> = ({ onSubmit }) => {
  const { t } = useTranslation();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [consent, setConsent] = useState<boolean>();

  const handleConsentSubmit = useCallback((value: boolean) => {
    setConsent(value);
    if (!value) {
      setIsSubmitted(true);
    }
  }, []);

  const handleSubmit = useCallback(
    (feedback: string) => {
      setIsSubmitted(true);
      onSubmit({ feedback });
    },
    [onSubmit]
  );

  return (
    <>
      <Box flexDirection="column" marginTop={1} marginBottom={1}>
        <Text>{t('user_feedback.title')}</Text>
        <Text skin="secondary">{t('user_feedback.subtitle')}</Text>
      </Box>
      <ConfirmInput
        initialValue={false}
        label={t('user_feedback.consent.label')}
        onSubmit={handleConsentSubmit}
      />
      {consent === true && (
        <TextInput
          label={t('user_feedback.comments.label')}
          onSubmit={handleSubmit}
        />
      )}
      {isSubmitted && (
        <Box flexDirection="column" marginTop={1}>
          <Text>
            {consent
              ? t('user_feedback.submitted')
              : t('user_feedback.declined')}
          </Text>
          <ContactUs />
        </Box>
      )}
    </>
  );
};
